<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id">
                <el-select
                        v-model="queryForm.shop_id"
                        filterable
                        remote
                        clearable
                        :remote-method="remoteShopMethod"
                        placeholder="请输入店铺">
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="投诉原因" prop="complaintReason">
                <el-select v-model="queryForm.complaintReason" placeholder="请选择">
                    <el-option label="超1小时未收到商品" value="1"></el-option>
                    <el-option label="漏商品、送错商品" value="2"></el-option>
                    <el-option label="商品质量问题" value="3"></el-option>
                    <el-option label="申请退款" value="4"></el-option>
                    <el-option label="投诉商家" value="5"></el-option>
                    <el-option label="投诉西游侠" value="6"></el-option>
                    <el-option label="投诉职能人员" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkmanTel">
                <el-input v-model="queryForm.linkmanTel" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="处理状态" prop="status">
                <el-select v-model="queryForm.status" placeholder="请选择">
                    <el-option label="新增投诉/待处理" value="0"></el-option>
                    <el-option label="已受理" value="1"></el-option>
                    <el-option label="处理完成" value="2"></el-option>
                    <el-option label="已判断" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否有效" prop="isValid">
                <el-select v-model="queryForm.isValid" placeholder="请选择">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期" prop="date">
                <el-date-picker
                        v-model="queryForm.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData(queryForm.pageNo=1)">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="$apiUrl.complaintList" :target="'oc'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>

        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="cityName"
                    label="城市名称"
                    :show-overflow-tooltip="true"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="schoolName"
                    label="学校名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="supplierShortName"
                    label="店铺名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="投诉时间"
                    width="180">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="linkmanTel"
                    label="联系电话"
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="complaintReason"
                    label="投诉原因"
                    width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.complaintReason==1">超1小时未收到商品</span>
                    <span v-if="scope.row.complaintReason==2">漏商品、送错商品</span>
                    <span v-if="scope.row.complaintReason==3">商品质量问题</span>
                    <span v-if="scope.row.complaintReason==4">申请退款</span>
                    <span v-if="scope.row.complaintReason==5">投诉商家</span>
                    <span v-if="scope.row.complaintReason==6">投诉西游侠</span>
                    <span v-if="scope.row.complaintReason==7">投诉职能人员</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="投诉状态"
                    width="150">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==0">新增投诉/待处理</span>
                    <span v-if="scope.row.status==1">已受理</span>
                    <span v-if="scope.row.status==2">处理完成</span>
                    <span v-if="scope.row.status==3">已判断</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="resultFeedback"
                    label="是否满意"
                    width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.resultFeedback==0">未反馈</span>
                    <span v-if="scope.row.resultFeedback==1">满意</span>
                    <span v-if="scope.row.resultFeedback==2">不满意</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="isValid"
                    label="是否有效"
                    :show-overflow-tooltip="true"
                    width="">
                <template slot-scope="scope">
                    <span>{{scope.row.isValid==0?'否':'是'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="160">
                <template slot-scope="scope">
                    <el-button type="text" @click="viewDetail(scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
<!--        <el-pagination-->
<!--                @size-change="handleSizeChange"-->
<!--                @current-change="handleCurrentChange"-->
<!--                :current-page="queryForm.pageNo"-->
<!--                :page-sizes="pageSizes"-->
<!--                :page-size="queryForm.pageSize"-->
<!--                layout="total, sizes, prev, pager, next"-->
<!--                :total="total">-->
<!--        </el-pagination>-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            prev-text="上一页"
            next-text="下一页"
            layout="prev, next">
        </el-pagination>

        <!--评价详情-->
        <el-dialog title="评价详情" :visible.sync="dialogVisible">
            <p class="bold">投诉信息</p>
            <p>投诉人：<span class="c6">{{complaintDetail.userName}}</span></p>
            <p>联系方式：<span class="c6">{{complaintDetail.linkmanTel}}</span></p>
            <p>
                投诉原因：
                <span class="c6">{{complaintDetail.complaintReason}}</span>
                <!--<span class="c6" v-if="complaintDetail.complaintReason==2">漏商品、送错商品</span>-->
                <!--<span class="c6" v-if="complaintDetail.complaintReason==3">商品质量问题</span>-->
                <!--<span class="c6" v-if="complaintDetail.complaintReason==4">申请退款</span>-->
                <!--<span class="c6" v-if="complaintDetail.complaintReason==5">投诉商家</span>-->
                <!--<span class="c6" v-if="complaintDetail.complaintReason==6">投诉西游侠</span>-->
                <!--<span class="c6" v-if="complaintDetail.complaintReason==7">投诉职能人员</span>-->
            </p>
            <p>
                投诉状态：
                <span class="blue" v-if="complaintDetail.status==0">新增投诉/待处理</span>
                <span class="blue" v-if="complaintDetail.status==1">已受理</span>
                <span class="blue" v-if="complaintDetail.status==2">处理完成</span>
                <span class="blue" v-if="complaintDetail.status==3">已判断</span>
            </p>
            <p v-if="complaintDetail.complaintContent">投诉内容：<span class="c6">{{complaintDetail.complaintContent}}</span></p>
            <p class="pb10">
                投诉图片：
                <img v-for="item in complaintDetail.picList" :src="item" width="60" height="60" alt="" style="margin-right: 10px;vertical-align: top;cursor: pointer" @click="preview(item)">
            </p>
            <p>
                <el-button size="mini" type="primary" @click="dispose(complaintDetail)" v-if="complaintDetail.status==0">受理投诉</el-button>
                <el-button size="mini" type="primary" @click="dispose(complaintDetail)" v-if="complaintDetail.status==1">反馈结果</el-button>
                <el-button size="mini" type="primary" @click="dispose(complaintDetail)" v-if="complaintDetail.status==2">是否有效</el-button>
            </p>
            <div class="line" style="margin-bottom:10px"></div>
            <p class="bold">投诉信息</p>
            <p>订单号：<span class="c6">{{orderDetail.id}}</span></p>
            <p>支付时间：<span class="c6">{{orderDetail.statusPayedTime}}</span></p>
            <p>
                订单状态：
                <span class="c6" v-if="orderDetail.orderStatus==1000">待付款</span>
                <span class="c6" v-if="orderDetail.orderStatus==1001">已支付</span>
                <span class="c6" v-if="orderDetail.orderStatus==2002">配送完成</span>
                <span class="c6" v-if="orderDetail.orderStatus==3001">确认收货</span>
                <span class="c6" v-if="orderDetail.orderStatus==9000">已取消</span>
                <span class="c6" v-if="orderDetail.orderStatus==8000">错误</span>
            </p>
            <p>联系电话：<span class="c6">{{orderDetail.consigneeTel}}</span></p>
            <p>联系地址：<span class="c6">{{orderDetail.fullAddressDetail}}</span></p>
            <p>
                商品列表：
                <el-table border :data="orderDetail.goodsDetailList">
                    <el-table-column property="title" label="商品名称" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{scope.row.isGift == 4 ? '' : scope.row.title}}
                        </template>
                    </el-table-column>
                    <el-table-column property="specification" label="规格" width="120"></el-table-column>
                    <el-table-column property="attribute" label="属性" width="120">
                        <template slot-scope="scope">
                            {{scope.row.isGift == 4 ? scope.row.title : scope.row.attribute}}
                        </template>
                    </el-table-column>
                    <el-table-column property="number" label="数量" width="120"></el-table-column>
                    <el-table-column property="salePrice" label="售价" width="120"></el-table-column>
                    <el-table-column property="amount" label="金额"></el-table-column>
                </el-table>
            </p>
            <p>打包费：<span class="c6">{{orderDetail.packingFeeReal}}</span></p>
            <p>配送费：<span class="c6">{{orderDetail.deliveryFee}}</span></p>
            <p class="pb10">总计：<span class="c6">{{orderDetail.realPay}}</span></p>
            <div class="line" style="margin-bottom:10px"></div>
            <p v-if="complaintDetail.recordList && complaintDetail.recordList.length>0" class="bold">处理记录</p>
            <div v-for="(item, index) in complaintDetail.recordList" :key="index">
                {{index+1}}、{{item.createTime}} {{item.handManName}}
                <span v-if="item.afterStatus==1">受理此投诉单</span>
                <span v-if="item.afterStatus==2">反馈投诉结果</span>
                <span v-if="item.afterStatus==3">判定投诉结果</span>
                <p>{{item.replyContent}}</p>
            </div>
        </el-dialog>
        <el-dialog
                title="预览"
                :visible.sync="innerVisible">
            <img :src="previewUrl" width="100%" alt="">
        </el-dialog>
        <!--受理-->
        <el-dialog
                :title="disposeTitle"
                :visible.sync="disposeVisible">
            <el-form size="mini" :model="disposeForm" :label-width="formLabelWidth" ref="disposeForm" :rules="rules">
                <el-form-item label="" prop="replyContent"  v-if="complaintDetail.status == 0 || complaintDetail.status == 1">
                    <el-input type="textarea" v-model="disposeForm.replyContent" placeholder="请输入（50个汉字以内）" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="" v-if="complaintDetail.status == 2">
                    <el-radio-group v-model="disposeForm.isValid">
                        <el-radio label="1">有效</el-radio>
                        <el-radio label="2">无效</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="disposeVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="loading1" @click="submitForm('disposeForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../../components/exportExcel2.vue";
    export default {
        components: {ExportExcel},
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1,
                    startDate: '',
                    endDate: '',
                    dateRange: [],
                    complaintReason: '',
                    shop_id: '',
                    linkmanTel: '',
                    status: '',
                    isValid: ''
                },
                shops: JSON.parse(localStorage.getItem('shops')),
                shopList: [],

                tableData: [],//表格数据
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果

                dialogVisible: false,
                complaintItem: {},
                complaintDetail: {},
                orderDetail: {},
                previewUrl: '',
                innerVisible: false,
                disposeVisible: false,
                disposeTitle: '',
                disposeForm: {
                    id: '',
                    operation: '',
                    handManId: this.$store.getters.userId,
                    handManName: this.$store.getters.username,
                    replyContent: '',
                    isValid: '1'
                },
                formLabelWidth: '0px',
                rules: {
                    replyContent: [
                        {required: true, message: '请输入结果', trigger: 'blur'},
                        {min: 1, max: 100, message: '长度在50个字符以内', trigger: 'blur'}
                    ]
                },
                loading1: false,

                //导出
                exportParams: {},
                fileName: '投诉统计表',
                fieldName: ['城市名称','学校名称','店铺名称','投诉时间','联系电话','投诉原因','投诉状态','是否满意','是否有效'],
                field: ['cityName','schoolName','supplierShortName','createTime','linkmanTel','complaintReason','status','resultFeedback','isValid']
            }
        },
        created(){
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];

            this.fetchData();
        },
        methods: {
            //抓取列表数据
            fetchData() {
                let params = {...this.queryForm};
                params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;

                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;

                this.$apiJava.post(this.$apiUrl.complaintList,params,(res)=>{
                    this.loading = false;
                    this.total = res.data.total || 0;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
            },
            //抓取列表数据
            exportExcel() {
                let params = {...this.queryForm};
                params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;

                params.pageSize = 99999;

                this.$apiJava.post(this.$apiUrl.complaintList,params,(res)=>{
                    this.tableDataAll = res.data.list || [];
                    if(this.tableDataAll.length > 0){
                        for(let v of this.tableDataAll){
                            if(v.resultFeedback == 0) v.resultFeedback = '未反馈';
                            if(v.resultFeedback == 1) v.resultFeedback = '满意';
                            if(v.resultFeedback == 2) v.resultFeedback = '不满意';

                            if(v.status == 0) v.status = '新增投诉/待处理';
                            if(v.status == 1) v.status = '已受理';
                            if(v.status == 2) v.status = '处理完成';
                            if(v.status == 3) v.status = '已判断';

                            if(v.complaintReason == 1) v.complaintReason = '超1小时未收到商品';
                            if(v.complaintReason == 2) v.complaintReason = '漏商品、送错商品';
                            if(v.complaintReason == 3) v.complaintReason = '商品质量问题';
                            if(v.complaintReason == 4) v.complaintReason = '申请退款';
                            if(v.complaintReason == 5) v.complaintReason = '投诉商家';
                            if(v.complaintReason == 6) v.complaintReason = '投诉西游侠';
                            if(v.complaintReason == 7) v.complaintReason = '投诉职能人员';

                            v.createTime = this.$utils.formatDate(v.createTime);
                            v.isValid = v.isValid==0?'否':'是';
                        }
                        let params = {
                            filename: this.fileName,
                            data: this.tableDataAll,
                            field: this.tableTitle,
                            fieldName: this.fieldName
                        }
                        this.$api.post(this.$apiUrl.exportExcel,params,(res)=>{
                            if(res.data) {
                                window.location.href = localStorage.getItem('domain') + res.data;
                            }
                        },(res)=>{
                            this.$message.warning(res.message);
                        })
                    }else{
                        this.$message.warning('没有可导出的数据');
                    }
                },(res)=>{
                    this.$message.warning(res.message);
                    this.tableDataAll = [];
                },'oc')
            },
            //查看详情
            viewDetail(item) {
                this.dialogVisible = true;
                if(item) this.complaintItem = item;
                this.$apiJava.get(this.$apiUrl.complaintDetail,{id: this.complaintItem.id},(res)=>{
                    this.complaintDetail = res.data.complaintDetail;
                    this.orderDetail = res.data.orderDetail;
                },null,'oc')
            },
            preview(item) {
                this.innerVisible = true;
                this.previewUrl = item;
            },
            //处理投诉
            dispose() {
                this.disposeVisible = true;
                if(this.complaintDetail.status == 0){
                    this.disposeTitle = '受理投诉';
                }else if(this.complaintDetail.status == 1){
                    this.disposeTitle = '反馈结果';
                }else if(this.complaintDetail.status == 2){
                    this.disposeTitle = '判定是否有效';
                }
            },
            //提交表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {...this.disposeForm};
                        params.operation = this.complaintDetail.status + 1;
                        params.id = this.complaintItem.id;

                        this.loading1 = true;
                        this.$apiJava.post(this.$apiUrl.complaintDispose,params,(res)=>{
                            this.loading1 = false;
                            this.$message.success('操作成功');
                            this.disposeVisible = false;
                            this.viewDetail();
                            this.fetchData();
                        },(res)=>{
                            this.loading = false;
                            this.$message.error(res.message);
                        },'oc')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            remoteShopMethod(query){
                if (query !== '') {
                    this.shopList = [];
                    var arr = [];
                    let len = this.shops.length;
                    var reg = new RegExp(query);
                    for(var i=0;i<len;i++){
                        //如果字符串中不包含目标字符会返回-1
                        if(this.shops[i].name.match(reg)){
                            this.shopList.push(this.shops[i]);
                        }
                    }
                } else {
                    this.shopList = [];
                }
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
//                this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.fetchData();
            }
        }
    }
</script>

<style lang="scss"  scoped>
    .el-dialog__body p{
        line-height: 35px;
    }
</style>


// WEBPACK FOOTER //
// list.vue?13c9cdd7